import { render, staticRenderFns } from "./DataFactory.vue?vue&type=template&id=b1e6c608&scoped=true"
import script from "./DataFactory.vue?vue&type=script&lang=js"
export * from "./DataFactory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e6c608",
  null
  
)

export default component.exports